import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {border, color, spacing} from "@khanacademy/wonder-blocks-tokens";
import {BodyMonospace} from "@khanacademy/wonder-blocks-typography";

export default function CodeInlineNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <BodyMonospace {...attributes} style={styles.code} tag="code">
            {children}
        </BodyMonospace>
    );
}

const styles = StyleSheet.create({
    code: {
        display: "inline",
        fontSize: 14,
        lineHeight: "1em",
        backgroundColor: color.offBlack8,
        paddingInlineStart: spacing.xxxxSmall_2,
        paddingInlineEnd: spacing.xxxxSmall_2,
        borderRadius: border.radius.radius_040,
    },
});
